import type { SVGProps } from "react";

export default function AspectRatioIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M7 9l4 0M7 9l0 4" />
      <path d="M17 15l-4 0M17 15l0-4" />
    </svg>
  );
}
